module.exports = __webpack_public_path__ + "static/media/input.97c3d318.svg";